// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1f8ZD","box":"WorkspacesBox_box__HbcIW","node":"WorkspacesBox_node__1B8Bx"};